export const ActivityColorCollection = ({ activityData }) => {
  const { collection } = activityData;

  return (
    <>
      {collection.imageUrl ? (
        <img
          src={collection.imageUrl}
          alt="Collection thumbnail"
          className="activity-feed-group-item__collection-thumbnail"
        />
      ) : (
        <div className="activity-feed-group-item__collection-colors-wrapper">
          {collection.colours.slice(0, 9).map((color, index) => {
            const colorStyles = { background: `rgb(${color.rgb})` };

            return (
              <div
                className="activity-feed-group-item__collection-colors-item"
                style={colorStyles}
                key={index}
              ></div>
            );
          })}
        </div>
      )}
    </>
  );
};
